export default __webpack_public_path__ + "static/media/happyguy.d375ea1e.png";